import { trackEvent } from '@notino/web-tracking';

export const trackLoyaltyCTA = (eventLabel: string) => {
  trackEvent({
    eventCategory: 'Service',
    eventAction: 'LoyaltyCTA',
    eventLabel,
    eventValue: undefined,
    eventNonInteraction: undefined,
  });
};
